import React, { useState, useEffect } from 'react';
import blackCard from '../../../assets/scard/black-card.jpeg';
import emeraldCard from '../../../assets/scard/emerald-card.jpeg';
import silverCard from '../../../assets/scard/silver-card.jpeg';

const images = [
  {
    original: blackCard,
    thumbnail: blackCard,
    id: 'black',
  },
  {
    original: emeraldCard,
    thumbnail: emeraldCard,
    id: 'emerald',
  },
  {
    original: silverCard,
    thumbnail: silverCard,
    id: 'silver',
  },
];

const Gallery: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [image, setImage] = useState(images[0]);
  useEffect(() => {
    setImage(images[index]);
  }, [index]);

  return (
    <div className="relative">
      <div className="space-y-2.5 w-full">
        <div className="relative cursor-pointer transition-transform hover:scale-[101%] overflow-hidden">
          <img
            src={image.original}
            alt=""
            className="overflow-hidden rounded-xl w-full aspect-square object-cover scale-[1.01]"
          />
        </div>
        <div className="mx-[-2px] grid grid-cols-3 gap-2 !mt-4">
          {images.map((item, idx) => {
            const isActive = idx === index;
            return (
              <div
                key={idx}
                className={`relative overflow-hidden border-2 aspect-square rounded-lg cursor-pointer ${isActive ? 'border-green/60' : 'border-transparent'}  transition-transform hover:scale-105`}
                onClick={() => setIndex(idx)}
              >
                <div className="absolute inset-0">
                  <div className="relative overflow-hidden">
                    <img
                      src={item.thumbnail}
                      alt=""
                      className="overflow-hidden w-full aspect-square object-cover scale-[1.01]"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
